import { render, staticRenderFns } from "./setDecimalDialog.vue?vue&type=template&id=06fe22be&scoped=true&"
import script from "./setDecimalDialog.vue?vue&type=script&lang=js&"
export * from "./setDecimalDialog.vue?vue&type=script&lang=js&"
import style0 from "./setDecimalDialog.vue?vue&type=style&index=0&id=06fe22be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fe22be",
  null
  
)

export default component.exports